import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY, //securely loads api key from environment variables
  authDomain: "vinirji.firebaseapp.com",
  projectId: "vinirji",
  storageBucket: "vinirji.firebasestorage.app",
  messagingSenderId: "257159570842",
  appId: "1:257159570842:web:69c44c4eddb2795bf14623",
  measurementId: "G-VDTCEPGLTJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Export the auth instance for use in your components
export const auth = getAuth(app);